import { Dispatch } from 'redux';
import { UserStoreStateType } from './types';
import axios from '../../utils/axios';
import { AxiosRequestConfig } from 'axios';
import SetStorageComponent, { clearStorageComponent, GetStorageComponent } from '../../utils/storage';

import config from '../../config/common';
import { showError } from '../../utils/alertNotification';
export interface Login {
  type: string;
  payload: UserStoreStateType;
}

export interface Register {
  type: string;
  payload: UserStoreStateType;
}

export interface Logout {
  type: string;
  payload: UserStoreStateType;
}

export type UserAction = Login | Register | Logout;

export const fetchUserInfo = () => {
  const accessToken = GetStorageComponent('access_token');

  return new Promise((resolve, reject) => {
    axios.request({
      method: 'get',
      url: `/users/info`,
      headers: {
        Authorization: 'bearer ' + accessToken
      },
      'noRetry': true
    } as AxiosRequestConfig).then((res) => {
      SetStorageComponent('userinfo', JSON.stringify(res.data));
      resolve(res.data)
    }).catch((err) => {
      reject();
      showError('Error Getting User Info')
    });
  })
}

export function logOutUser(): (dispatch: Dispatch<UserAction, any>) => void {
  return function (dispatch: Dispatch<UserAction, any>) {
    clearStorageComponent();
    window.location.href = `${config.account_url}/logout?redirect_url=${config.redirect_url}`;
  };
}

export function hideWelcome(): (dispatch: Dispatch<UserAction, any>) => void {
  return function (dispatch: Dispatch<UserAction, any>) {
    dispatch({
      type: 'SHOW_WELCOME_MSG',
      payload: {
        user: {
          showWelcome: false
        }
      } as any
    });
  };
}
